module.exports = __webpack_public_path__ + "static/media/logo-sanitas.a52df0d0.png";